
import { Component, Mixins } from "vue-property-decorator";
import { IImageDrawable } from "../../../../../domain/document/items";

@Component({
})
export default class ImageDrawableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: IImageDrawable) => T, defaultValue: T) => T;

  get imageSource(): any {
    return this.readPropertyOrDefault(s => s.imageSource.source, null);
  }
}
